<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { createDomI18nController } from '@/i18n/dom-translator'

export default {
  name: 'App',
  data() {
    return {
      domI18nController: null
    }
  },
  mounted() {
    this.domI18nController = createDomI18nController(() => document.getElementById('app'))
    this.domI18nController.start()
  },
  beforeUnmount() {
    if (this.domI18nController) {
      this.domI18nController.stop()
      this.domI18nController = null
    }
  }
}
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
